module.exports = __webpack_public_path__ + "img/add_new_payment_btn_card.c8a7b68f.svg";